var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlternativeMedicine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31_0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: "current",
      height: "current",
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:current;stroke:current}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.031,119.07h-84.504V62.586c0-23.43-19.086-42.516-42.554-42.516H148.031 c-23.469,0-42.558,19.086-42.558,42.516v56.472v0.012h-84.5C9.422,119.07,0,128.492,0,140.043v39.086v0.238l0,0v0.16h105.473h53.25 h194.559h53.246H512v-39.484C512,128.492,502.539,119.07,491.031,119.07z M353.282,73.317v45.754H158.722V73.317H353.282z",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,250.348c-26.297,0-49.93,11.878-65.742,30.515c-12.734,15.031-20.438,34.406-20.438,55.622 c0,47.515,38.668,86.179,86.18,86.179c47.516,0,86.141-38.664,86.141-86.179c0-21.215-7.703-40.59-20.398-55.622 C305.89,262.226,282.297,250.348,256,250.348z M238.512,391.25v-28.754c0-4.71-3.809-8.476-8.481-8.476h-28.793 c-1.722,0-3.114-1.395-3.114-3.118V322.11c0-1.719,1.391-3.114,3.114-3.114h28.793c4.672,0,8.481-3.809,8.481-8.476v-28.758 c0-0.328,0.038-0.613,0.164-0.898c0.367-1.27,1.554-2.21,2.906-2.21h28.797c1.39,0,2.578,0.941,2.949,2.21 c0.122,0.286,0.164,0.57,0.164,0.898v28.758c0,4.667,3.809,8.476,8.477,8.476h28.797c1.68,0,3.07,1.394,3.07,3.114v28.793 c0,1.722-1.39,3.118-3.07,3.118h-28.797c-4.668,0-8.477,3.766-8.477,8.476v28.754c0,1.718-1.394,3.113-3.113,3.113h-28.797 C239.902,394.363,238.512,392.969,238.512,391.25z",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.282,198.656H158.722h-53.25H0v272.301c0,11.512,9.422,20.973,20.973,20.973h470.058 c11.508,0,20.969-9.461,20.969-20.973V198.656H406.527H353.282z M256,447.45c-61.195,0-110.961-49.77-110.961-110.965 c0-20.234,5.449-39.278,15.031-55.622c15.813-27.199,42.847-47.062,74.754-53.246h42.352c31.867,6.183,58.941,26.046,74.714,53.246 c9.582,16.344,15.031,35.387,15.031,55.622C366.922,397.68,317.156,447.45,256,447.45z",
    style: {
      fill: "rgb(75, 75, 75)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlternativeMedicine);
export default __webpack_public_path__ + "static/media/AlternativeMedicine.d9668b5ae2ef89161a2a11906bbb2cc6.svg";
export { ForwardRef as ReactComponent };